import { createDecorator } from '../../instantiation/common/instantiation.js';
const IWorkspaceContextService = ( createDecorator('contextService'));
export { IWorkspaceContextService };
